import importerStore from '@shared/importer/importer-store';
import { PriceService } from '@modules/price/price-service';
import priceImporterFields from '@modules/price/price-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  PriceService.import,
  priceImporterFields,
  i18n('entities.price.importer.fileName'),
  i18n('entities.price.importer.hint'),
);
